import React from 'react'
import { Pane, Heading } from 'evergreen-ui'
import { TimePicker } from 'antd'
import 'antd/dist/antd.css'
import moment from 'moment'
import {
  getTimeObject,
  checkIfTimeIsAfter,
  checkIfTimeIsBefore,
  getMomentTimeObj1
} from '../util'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

const TimeRangePicker = props => {
  const {
    fromTime,
    toTime,
    currentTime,
    timeChange,
    paddingLeft,
    paddingRight,
    step,
    saveTemporary,
    handleTimeChange
  } = props

  const fromTimeChange = time => {
    let { toTime } = props
    const timeObject = getTimeObject(time, 'h:mm A')
    const toTimeObject = getTimeObject(toTime)
    if (checkIfTimeIsAfter(timeObject, toTimeObject)) {
      toTime = timeObject
    }
    timeChange &&
      timeChange({
        fromTime: timeObject.format('HH:mm:ss'),
        toTime: getTimeObject(toTime).format('HH:mm:ss')
      })

    handleTimeChange &&
      handleTimeChange(
        { startTime: timeObject.format('HH:mm:ss') },
        timeObject.format('HH:mm:ss')
      )
  }

  const toTimeChange = time => {
    let tt = getTimeObject(time, 'h:mm A').format('HH:mm:ss')
    let { fromTime } = props
    const timeObject = getTimeObject(time, 'h:mm A')
    const fromTimeObject = getTimeObject(fromTime)
    let timeTest = checkIfTimeIsBefore(timeObject, fromTimeObject)

    if (checkIfTimeIsBefore(timeObject, fromTimeObject) && tt !== '00:00:00') {
      console.log('okoko')
      fromTime = timeObject
    }
    timeChange &&
      timeChange({
        toTime: timeObject.format('HH:mm:ss'),
        fromTime: getTimeObject(fromTime).format('HH:mm:ss')
      })

    handleTimeChange &&
      handleTimeChange(
        { endTime: timeObject.format('HH:mm:ss') },
        timeObject.format('HH:mm:ss')
      )
  }

  return (
    <Pane
      display={'flex'}
      justifyContent={'space-between'}
      paddingLeft={paddingLeft}
      paddingRight={paddingRight}
    >
      <Pane marginRight={10} display={'flex'} flexDirection={'column'}>
        <Heading marginBottom={4} size={400} color={'#425A70'}>
          From
        </Heading>
        {/* <TimePicker
          inputReadOnly='false'
          className={'time-picker'}
          onClick={e => saveTemporary && saveTemporary(e, 'startTime')}
          defaultValue={currentTime}
          value={getTimeObject(fromTime)}
          format={'h:mm A'}
          minuteStep={step || 1}
          onChange={e => {
            document.querySelector('.time-picker input').blur()
            fromTimeChange(e.format('h:mm A'))
          }}
        /> */}
        <Pane onClick={e => saveTemporary && saveTemporary(e, 'startTime')}>
          <DatePicker
            className={'time-picker'}
            selected={getMomentTimeObj1(fromTime)}
            onChange={e => {
              fromTimeChange(e)
            }}
            showTimeSelect
            showTimeSelectOnly
            timeIntervals={30}
            dateFormat={'h:mm aa'}
            timeCaption='From'
          />
        </Pane>
      </Pane>
      <Pane marginLeft={''} display={'flex'} flexDirection={'column'}>
        <Heading marginBottom={4} size={400} color={'#425A70'}>
          To
        </Heading>
        <Pane onClick={e => saveTemporary && saveTemporary(e, 'endTime')}>
          <DatePicker
            className={'time-picker'}
            selected={getMomentTimeObj1(toTime)}
            onChange={e => {
              toTimeChange(e)
            }}
            showTimeSelect
            showTimeSelectOnly
            timeIntervals={30}
            dateFormat={'h:mm aa'}
            timeCaption='To'
          />
        </Pane>
      </Pane>
    </Pane>
  )
}

export default TimeRangePicker
